import { css } from '@emotion/react';
import { Modal, Type } from '@robinhood/design';
import { NeutralColorToken } from '@robinhood/design';
import { E164ToNational } from '@x1/util-format';

import Button from 'src/components/creditApplication/Button';

interface PropsIface {
  e164?: string;
  onLandline: () => void;
  onDismiss: () => void;
}

const LandlineModal = ({ e164, onLandline, onDismiss }: PropsIface) => {
  return (
    <Modal width='wide' overrideModalStyles={root} onClose={onDismiss}>
      <div css={textContainer}>
        <Type.Display size='S'>Help with fraud alerts</Type.Display>
        <Type.Text size='M'>
          {`If you know the number, but it’s a landline, click here. A team member will call ${
            e164 ? E164ToNational(e164) : 'your phone number'
          } within 7 days to verify your identity.`}
        </Type.Text>
      </div>
      <div css={buttonContainer}>
        <Button label='Number is a landline' width='full' type='button' onClick={onLandline} />
        <Button
          label='Dismiss'
          width='full'
          type='button'
          onClick={onDismiss}
          foregroundColor={NeutralColorToken.Fg1}
        />
      </div>
    </Modal>
  );
};

const root = css`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 24px;
`;

const textContainer = css`
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: center;
`;

const buttonContainer = css`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export default LandlineModal;
